import { useQuery } from '@tanstack/react-query';
import { setupApiClient } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetAllPlannings = () =>
  useQuery({
    queryKey: ['financial-planning', 'all'],
    queryFn: getAllPlannings,
  });

const getAllPlannings = async () => {
  const api = setupApiClient({}, true);
  const { data } = await api.get<GetAllPlanningsResponse>(
    apiConfig.routes.financialPlanning.planners
  );
  return data.financialPlan;
};

type GetAllPlanningsResponse = {
  financialPlan: {
    id: number;
  };
};
